import React, { useState, useEffect } from 'react';
import '../../styles/index.scss';
import { string, node, bool, shape } from 'prop-types';
import mixpanel from 'mixpanel-browser';
import styles from './layout.module.scss';
import Header from '../Header';
import Footer from '../Footer';
import Head from '../Head';
import Menu from '../Menu';
import variables from '../../styles/variables.module.scss';
// import Cookie from '../Cookie';
// import { getCookie, setCookie, VISIT_COOKIE } from '../../utils';
mixpanel.init('da481968e3cf797aff0554ce7d3939dd');

const Layout = ({ location, offset, children }) => {
  const [menuHidden, setMenuHidden] = useState(true);
  // const [showCookie, setShowCookie] = useState(true);

  useEffect(() => {
    const body = '👋, welcome to We App! 🦄';
    console.log( // eslint-disable-line
      `%c${body}`,
      `color:${variables.springGreen};
        font-weight: normal;
        background-color: ${variables.carbonBlack};
        padding: 10px;
        border: 2px solid ${variables.springGreen}
      `
    );
    // setShowCookie(!getCookie(VISIT_COOKIE));
  }, []);

  // const onCloseCookie = () => {
  //   setCookie(VISIT_COOKIE, 'true', 30);
  //   setShowCookie(false);
  // };

  const { pathname } = location;
  let pathNameString = pathname;
  if (
    pathname.length > 1 &&
    pathname.substr(pathname.length - 1) === '/'
  ) {
    pathNameString = pathname.substr(
      0,
      pathname.length - 1
    );
  }
  return (
    <div
      className={[
        styles.container,
        !menuHidden && styles.noScroll,
      ].join(' ')}
    >
      <Menu
        toggleMenu={() => {
          setMenuHidden(!menuHidden);
          if (menuHidden) {
            mixpanel.track('MenuPressedOpen');
          } else {
            mixpanel.track('MenuPressedClose');
          }
        }}
        menuHidden={menuHidden}
        pathname={pathNameString}
      />
      <Head pathname={pathNameString} />
      {
        <Header
          menuHidden={menuHidden}
          toggleMenu={() => {
            setMenuHidden(!menuHidden);
            if (menuHidden) {
              mixpanel.track('MenuPressedOpen');
            } else {
              mixpanel.track('MenuPressedClose');
            }
          }}
        />
      }
      <div
        className={[
          styles.content,
          offset ? styles.offset : undefined,
        ].join(' ')}
      >
        {children}
      </div>
      <Footer />
      {/*  showCookie && <Cookie onClose={onCloseCookie} /> */}
    </div>
  );
};

Layout.propTypes = {
  location: shape({
    pathname: string,
  }).isRequired,
  offset: bool,
  children: node.isRequired,
};

Layout.defaultProps = {
  offset: false,
};

export default Layout;
